import { render, staticRenderFns } from "./lessonPage.vue?vue&type=template&id=31869c9a&scoped=true&"
import script from "./lessonPage.vue?vue&type=script&lang=ts&"
export * from "./lessonPage.vue?vue&type=script&lang=ts&"
import style0 from "./lessonPage.vue?vue&type=style&index=0&id=31869c9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31869c9a",
  null
  
)

export default component.exports